export enum ReceiptType {
  Sell = 'Sell',
  SellReturn = 'SellReturn',
}

export enum SNOType {
  OSN = 'общая',
  USNIncome = 'упрощенная доход',
  USNIncomeOutcome = 'упрощенная доход минус расход',
  ESN = 'единый сельскохозяйственный доход',
  Patent = 'патентная система налогообложения',
}

export interface ReceiptItem {
  name: string;
  price: number;
  quantity: number;
  unit: string;
  supplierName: string;
  supplierINN: string;
  supplierPhoneNumber: string;
  taxVatType: string;
  vatPercent: string;
}

export interface Receipt {
  id: number;
  orderId: number;
  type: ReceiptType;
  amount: number;
  sno: SNOType;
  operatorName: string | null;
  operatorINN: string | null;
  organizationName: string | null;
  organizationINN: string | null;
  organizationAddress: string | null;
  paymentsAddress: string | null;
  shiftNumber: number | null;
  documentNumber: number | null;
  documentDate: string | null;
  fiscalSign: string | null;
  serialNumber: string | null;
  fnSerialNumber: string | null;
  ercRegNumber: string | null;
  items: ReceiptItem[] | null;
  siteAddress: string;
  clientEmailOrPhone: string;
  vatTaxAmounts: VatTaxAmounts[]; 
}

interface VatTaxAmounts {
  taxVatType: string;
  amount: number;
  vatPercent: string;
}
